import React from 'react'

import { TopImageContent, NoImageContent, LeftImageContent } from '..'
import { SectionProps } from '../../../../core/types/Help'
import { Text, SectionTitle, List } from '../ContentItem'
import { HELP_IMAGES } from '../../../constants/HelpImages'
import { buildDynamicCopy } from '../../../../core/utils/Localization'

const RecurringTransactions: React.FC<SectionProps> = ({ copy }) => {
  const copyContent = copy.recurring_transactions

  const recurringTransactionSections = {
    overviewSsction: (
      <TopImageContent
        altImage={copyContent.overview_alt_image}
        content={
          <Text
            content={
              buildDynamicCopy(
                copyContent.overview_description,
                <b>{copyContent.recurring_transactions}</b>,
              ) as React.ReactNode
            }
          />
        }
        image={HELP_IMAGES.RECURRING_TRANSACTIONS_OVERVIEW}
        imageLargeBreakPoint={7}
        sx={{ pt: 24 }}
      />
    ),
    calendarSection: (
      <NoImageContent
        content={
          <Text
            content={
              buildDynamicCopy(
                copyContent.calendar_dec,
                <b>{copyContent.calendar_bold}</b>,
              ) as React.ReactNode
            }
          />
        }
      />
    ),
    editSsction: (
      <LeftImageContent
        altImage={copyContent.manage_alt_image}
        content={
          <React.Fragment>
            <Text
              content={
                buildDynamicCopy(
                  copyContent.edit_recurring_transaction_dec_1,
                  <b>{copyContent.edit_recurring_transaction_dec_bold_1}</b>,
                  <b>{copyContent.edit_recurring_transaction_dec_bold_2}</b>,
                  <b>{copyContent.edit_recurring_transaction_dec_bold_3}</b>,
                ) as React.ReactNode
              }
            />
            <Text content={copyContent.edit_recurring_transaction_dec_2} />
          </React.Fragment>
        }
        image={HELP_IMAGES.RECURRING_TRANSACTIONS_MANAGE_EXPENSES}
      />
    ),
    paymentFrequencySection: (
      <LeftImageContent
        altImage={copyContent.payment_alt_image}
        content={
          <React.Fragment>
            <Text content={copyContent.payment_frequency_dec_1} />
            <List
              items={[
                copyContent.payment_list_item_1,
                copyContent.payment_list_item_2,
                copyContent.payment_list_item_3,
                copyContent.payment_list_item_4,
                copyContent.payment_list_item_5,
                copyContent.payment_list_item_6,
                copyContent.payment_list_item_7,
              ]}
              listType="ul"
            />
            <Text content={copyContent.payment_frequency_dec_2} sx={{ pt: 24 }} />
          </React.Fragment>
        }
        hasDivider={false}
        image={HELP_IMAGES.RECURRING_TRANSACTIONS_EXPENSE_DETAILS}
      />
    ),
  }

  return (
    <React.Fragment>
      {recurringTransactionSections.overviewSsction}
      <SectionTitle content={copyContent.calendar_title} sx={{ pt: 48 }} />
      {recurringTransactionSections.calendarSection}
      <SectionTitle content={copyContent.edit_recurring_transaction_title} sx={{ pt: 48 }} />
      {recurringTransactionSections.editSsction}
      <SectionTitle content={copyContent.payment_frequency_title} sx={{ pt: 48 }} />
      {recurringTransactionSections.paymentFrequencySection}
    </React.Fragment>
  )
}

export default RecurringTransactions
